<template>
  <div class="app-header">
    <div class="d-flex">
      <button
        v-if="showSidebar"
        class="navbar-toggler hamburger hamburger--elastic toggle-sidebar"
        v-bind:class="{ 'is-active': sidebarCollapsed }"
        type="button"
        v-on:click="toggleSidebar"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <button
        v-if="showSidebar"
        class="
          navbar-toggler
          hamburger hamburger--elastic
          toggle-sidebar-mobile
        "
        v-bind:class="{ 'is-active': sidebarCollapsedMobile }"
        type="button"
        v-on:click="toggleSidebarMobile"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <!-- <div class="nav-logo text-center ml-3">
        <router-link
          class="d-block"
          active-class="active"
          to="/"
          exact
          v-b-tooltip.hover
        >
          <img src="@/assets/img/logo.png" style="width: 50px; height: 100%" />
        </router-link>
      </div> -->
      <!-- <div class="search-link">
                <div class="d-none d-lg-flex align-items-center">
                    <font-awesome-icon icon="search" class="search-icon w-auto" />
                    <input type="text" placeholder="Click here to search...">
                </div>
                <div class="d-none d-sm-flex d-lg-none">
                    <b-button variant="outline-primary" size="sm" class="px-3" v-b-modal.search-modal>
                        <font-awesome-icon icon="search" />
                    </b-button>
                </div>
            </div> -->
    </div>

    <div class="d-flex align-items-center">
      <!-- <b-button
        v-if="showAuth && authUser"
        variant="link"
        target="_blank"
        class="toggle-sidebar"
        href="https://d10a8qjc50njp0.cloudfront.net/misc/%E0%B9%83%E0%B8%9A%E0%B8%AA%E0%B8%A1%E0%B8%B1%E0%B8%84%E0%B8%A3%E0%B8%AA%E0%B8%A1%E0%B8%B2%E0%B8%8A%E0%B8%B4%E0%B8%81%E0%B8%8A%E0%B8%A1%E0%B8%A3%E0%B8%A1+D.A.R.E.+%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B9%84%E0%B8%97%E0%B8%A2.pdf"
        >ใบสมัครสมาชิกชมรม D.A.R.E. ประเทศไทย</b-button
      > -->
      <b-button
        v-if="showAuth && authUser"
        variant="link"
        target="_blank"
        class="toggle-sidebar"
        href="https://drive.google.com/file/d/1dN0fQpS5XgoTFVNIP-9_lswylqEut-4Z/view"
        >คู่มือการใช้งานระบบ</b-button
      >

      <router-link
        v-if="showAuth && authUser"
        class="toggle-sidebar"
        active-class="active"
        to="/tutorials"
        exact
      >
        วีดีโอสอนการใช้งานระบบ
      </router-link>
        
      <sign-out v-if="showAuth && authUser" />
    </div>

    <!-- <b-modal id="search-modal" centered>
            <div slot="modal-header">
                <h6 class="display-4 font-weight-bold">Search</h6>
                <p class="text-black-50 mb-0">Use the form below to search for files</p>
            </div>
            <div class="p-5">
                <div class="input-group">
                    <input type="search" class="form-control" placeholder="Search terms here..." />
                    <div class="input-group-append">
                        <b-button variant="primary" class="border-0">
                            <font-awesome-icon icon="search" />
                        </b-button>
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="d-block w-100">
                <b-button variant="link" block class="btn-link-dark" @click="$bvModal.hide('search-modal')">Close search box</b-button>
            </div>
        </b-modal> -->
  </div>
</template>

<script>
import SignOut from "../header/SignOut";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Auth } from "../../models";

library.add(faSearch);

export default {
  props: {
    showSidebar: Boolean,
    showAuth: Boolean,
  },

  components: {
    SignOut,
  },

  computed: {
    sidebarCollapsed: {
      get() {
        return this.$store.state.sidebarCollapsed;
      },
      set(value) {
        this.$store.commit("SET_SIDEBAR_COLLAPSED", value);
      },
    },
    sidebarCollapsedMobile: {
      get() {
        return this.$store.state.sidebarCollapsedMobile;
      },
      set(value) {
        this.$store.commit("SET_SIDEBAR_COLLAPSED_MOBILE", value);
      },
    },

    authUser() {
      return Auth.getAuthId();
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    toggleSidebarMobile() {
      this.sidebarCollapsedMobile = !this.sidebarCollapsedMobile;
    },
  },
};
</script>
